import React, { useState } from 'react'
import { Link } from 'react-router-dom';
import Card from "../../../../components/Card";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const CourseCard = ({ course }) => {
    const [loading, setLoading] = useState(true);
    // console.log(course, "coishfewrewrnernfen");

    return (
        <Link to={`/training-videos`}
            state={{ course }}
            onClick={() => {
                localStorage.setItem("current-course", JSON.stringify(course));
            }}
        >
            <Card className="card-block card-stretch card-height product">
                <div
                    style={{
                        boxShadow:
                            "rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px",
                        borderRadius: "10px",
                    }}
                >
                    <Card.Body>
                        <div className="image-block position-relative productCardImg overflow-hidden">
                            {loading && <Skeleton height={200} className="rounded-3" />}
                            <img
                                src={course?.logo_image}
                                className="img-fluid w-100 h-100 object-fit-cover rounded"
                                alt="product-img"
                                style={{ display: loading ? "none" : "block" }}
                                onLoad={() => setLoading(false)}
                            />
                        </div>
                        <div className="product-description mt-3 d-flex flex-column gap-1">
                            <div
                                className="mb-1"
                                style={{ fontSize: "19px", fontWeight: "600" }}
                            >
                                {course?.title}
                            </div>
                        </div>
                    </Card.Body>
                </div>
            </Card>
        </Link>
    );
};

export default CourseCard